import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'

class CartCopy extends Component {
  componentDidMount() {
    this.props.receivedExternalCart()

    if (this.props.readyToRedirect) {
      this.redirectToNextPage()
    }
  }

  componentDidUpdate() {
    if (this.props.readyToRedirect) {
      this.redirectToNextPage()
    }
  }

  redirectToNextPage() {
    const { routeParams, location } = this.props
    const { orderFormId } = routeParams
    const { forceIdentification } = location.query

    if (!orderFormId) {
      this.props.goToCartPage(forceIdentification)
    } else {
      this.proceedWithCartCopy()
    }
  }

  proceedWithCartCopy() {
    const { orderFormId, code } = this.props.routeParams
    const { forceIdentification, next } = this.props.location.query
    const { pathname } = this.props.location

    if (pathname.indexOf('cart-change') > -1) {
      this.props.changeCart(orderFormId, forceIdentification, next, code)
    } else if (pathname.indexOf('cart-copy') > -1) {
      this.props.copyCart(orderFormId, forceIdentification, next)
    } else {
      this.props.goToCartPage(forceIdentification)
    }
  }

  render() {
    return (
      <div className="flex flex-column  flex-auto items-center justify-center f2">
        <i className="fa fa-circle-notch fa-spin fa-fw o-30" />
      </div>
    )
  }
}

CartCopy.propTypes = {
  location: PropTypes.object,
  routeParams: PropTypes.object,
  router: PropTypes.any,
  readyToRedirect: PropTypes.bool.isRequired,
  copyCart: PropTypes.func.isRequired,
  changeCart: PropTypes.func.isRequired,
  goToCartPage: PropTypes.func.isRequired,
  orderFormSuccess: PropTypes.func.isRequired,
  receivedExternalCart: PropTypes.func.isRequired,
}

export default withRouter(CartCopy)
